import babelpolyfill from 'babel-polyfill'
  import Vue from 'vue'
import App from './App'
import 'normalize.css'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
  import Vuex from 'vuex'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import router from './router'
import 'font-awesome/css/font-awesome.min.css'
import './assets/scss/main.scss';
import VueCookies from 'vue-cookies'
import moment from 'moment'
import 'moment/locale/zh-cn'
import filters from './common/js/filter.js'
import VueElementExtends from 'vue-element-extends'
import 'vue-element-extends/lib/index.css'
import echarts from 'echarts'
// import 'echarts/theme/dark.js'
// import 'echarts/theme/infographic.js'
// import 'echarts/theme/macarons.js'
// import 'echarts/theme/roma.js'
// import 'echarts/theme/shine.js'
// import 'echarts/theme/vintage.js'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import Blob from './excel/Blob.js'
import Export2Excel from './excel/Export2Excel.js'
import VueImageSwipe from 'vue-image-swipe'
import 'vue-image-swipe/dist/vue-image-swipe.css'
import login from './common/js/login.js'
import paramUtil from './common/js/param_util.js'
import 'babel-polyfill'
// import dataV from '@jiaminghi/data-view'
// import ElComboGrid from './components/ComboGrid/combogrid.vue';
import {
	post,
	get,
	getExternalUrl,
	postExternalUrl,
	basicPost, 
	getWeather,
	getColumnSetByMenuId
} from './common/js/request.js'
import util from './common/js/util.js'
import bus from './components/Tabs/bus.js'
import global_variable from './store/global_variable'
import Mixin from './common/js/mixin.js';
import comboxgrid from './components/ComboGrid/comboxgrid.js'
Vue.mixin(Mixin);
// Vue.component('el-combo-grid',ElComboGrid)

 
Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.prototype.util = util;
Vue.prototype.bus = bus;
Vue.prototype.$paramUtil = paramUtil;
Vue.prototype.$GLOBAL = global_variable;
Vue.prototype.$login = login;
Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$basicPost = basicPost; 
Vue.prototype.$getWeather = getWeather;
Vue.prototype.$getColumnSetByMenuId = getColumnSetByMenuId;
Vue.prototype.$echarts = echarts;
Vue.prototype.$height = 258;
Vue.prototype.$dialogHeight = 260; //弹窗排除的高度
Vue.prototype.$mainHeight = 136; //编辑界面排除的高度
Vue.prototype.$amountdigit = 2; //资产的小数位数
Vue.prototype.$moment = moment; //赋值使用 
Vue.prototype.$getExternalUrl = getExternalUrl;
Vue.prototype.$postExternalUrl = postExternalUrl;
// const httpURL = 'http://192.168.2.18:5006';
Vue.use(ElementUI, {
	size: 'small'
});
 Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(VueElementExtends)
Vue.use(Viewer)
Vue.use(VueImageSwipe)
// Vue.use(dataV)
Vue.use(comboxgrid)
//使用钩子函数对路由进行权限跳转
router.beforeEach((to, from, next) => {  
	if (to.path == '/mes_version_detail'  ) {
		next();
		return;
	} 
	const role = VueCookies.isKey("hy_login_token");
	if (!role && to.path !== '/login') { 
		next('/login');
	} else { 
		next();
	}
})

router.afterEach(transition => {
	NProgress.done();
});

// 初始化vue-bmap
// VueBMap.initBMapApiLoader({
//   // 百度的key
//   ak: '1TehBcGjhvsG1GeihlGkFHyTtCdHDjxc',
//   // 百度 sdk 版本，默认为 1.0
//   v: '1.0'
// });
new Vue({
	router,
	render: h => h(App)
}).$mount('#app')


import GlobalJson from './common/js/global-json.js'
Vue.prototype.$GlobalJson = GlobalJson;



// WEBPACK FOOTER //
// ./src/main.js